import React from "react";
import Navbar from "../Navbar/Navbar";
import SearchForm from "../SearchForm/SearchForm";
import "./Header.css";

const Header = () => {
  return (
    <div className="holder">
      <header className="header bg">
        <Navbar />
        <div className="header-content flex flex-c text-center text-white">
          <h2 className="header-title text-capitalize">
            Find your book of choice
          </h2>
          <p className="header-text fs-18 fw-3">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. A iusto ut
            at incidunt officia. At repellendus dignissimos esse sit itaque
            eaque voluptatum hic delectus sint.
          </p>
          <SearchForm />
        </div>
      </header>
    </div>
  );
};

export default Header;
